'use strict';

exports.__esModule = true;
exports.isPromise = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-router/lib/PromiseUtils.js
 ** module id = 204
 ** module chunks = 3
 **/